<div class="main">
    <div class="search-panel">
        <div style="flex-grow: 1">
            <dx-text-box
                #inputTextBox
                label="เลขทะเบียนนิติบุคคล หรือ ชื่อบริษัท"
                [(value)]="inputTaxId"
                valueChangeEvent="input change"
                (onEnterKey)="onSearchClick()"
                (onBlur)="normalizeTaxIdInput()"
                [disabled]="isLoading"
            ></dx-text-box>
        </div>
        <div class="separator">|</div>
        <div>
            <dx-button
                text="ค้นหา"
                icon="search"
                stylingMode="outlined"
                type="default"
                (onClick)="onSearchClick()"
                [disabled]="isLoading"
            >
            </dx-button>
        </div>
        <div>
            @if (isLoading) {
            <dx-load-indicator height="30" width="30"></dx-load-indicator>
            }
        </div>
    </div>

    <!-- Loading, name matches, and the empty state are mutually exclusive;
         branch tags keep that readable instead of re-testing !isLoading. -->
    <div class="result-panel">
        @if (isLoading) {
        <div class="msg-box">{{ statusMsg }}</div>
        } @else if (companyMatches.length) {
        <div class="msg-box">เลือกบริษัทเพื่อดูที่อยู่และสาขา</div>
        @for (match of companyMatches; track match.taxId) {
        <button
            type="button"
            class="company-match"
            (click)="onCompanyMatchClick(match)"
        >
            <span class="company-match-name">{{ match.name }}</span>
            <span class="company-match-taxid">{{ match.taxId }}</span>
        </button>
        } } @else if (isLoaded && !ctpVms.length) {
        <div class="msg-box">{{ emptyMessage }}</div>
        } @else { @for (ctpVm of ctpVms; track ctpVm) {
        <app-counterparty-card
            [ctpVm]="ctpVm"
            (selectButtonClickEvent)="onSelectButtonsClicked($event)"
        >
        </app-counterparty-card>
        } }
    </div>
</div>
